import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { SectionHeading } from '@/components/landing/section-heading'
import { ConsortiumCard } from '@/components/landing/consortium-card'
import { consortiumCategories } from '@/constants/consorcios'

const layout = [
    { tone: 'ink', size: 'large', className: 'md:col-span-2 lg:col-span-3' },
    { tone: 'gold', size: 'large', className: 'lg:col-span-3' },
    { tone: 'plain', size: 'regular', className: 'lg:col-span-2' },
    { tone: 'plain', size: 'regular', className: 'lg:col-span-2' },
    { tone: 'plain', size: 'regular', className: 'lg:col-span-2' }
] as const

export const CategoriesSection: FC = (): ReactNode => {
    return (
        <section id='consorcios' aria-labelledby='consorcios-titulo' className='py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        id='consorcios-titulo'
                        eyebrow='Tipos de consórcio'
                        title='Um consórcio para cada conquista'
                        description='Do primeiro apartamento à frota da empresa. Escolha o tipo de crédito e veja prazos, parcelas e o que dá para comprar em cada plano.'
                    />

                    <p className='max-w-xs text-sm leading-relaxed text-muted-foreground lg:text-right'>
                        Valores de referência. As condições finais dependem da administradora e do grupo escolhido.
                    </p>
                </div>

                <ul className='mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-6'>
                    {consortiumCategories.map((category, index) => {
                        const item = layout[index] ?? layout[2]

                        return (
                            <li key={category.slug} className={cn(item.className)}>
                                <ConsortiumCard category={category} tone={item.tone} size={item.size} />
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}
